<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$('.p-readmore').on('click', function() {
  console.log(1);
  $('a[href="#tab-description-mobile"]').addClass('is-open');
  $('#tab-description-mobile').css('display', 'block');
})